module.exports = __webpack_public_path__ + "img/small.840604d0.jpg";